import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState() {
  return {
    global_level: {},
    screener_level: {}
  };
}

const state = initialState();

// actions

const actions = {
  async updateScreenerConfig(context, payload) {
    await context.commit("update_screener_config", payload);
  },

  async markPrerollEnded(context, payload) {
     context.commit("mark_preroll_ended", payload);
  },

  async updateMovieIndex(context, payload) {
     context.commit("update_movie_index", payload);
  },

  async updateCurrentTime(context, payload) {
    context.commit("update_current_time", payload);
  },

  async updateScreenerSubtitle(context, payload) {
    context.commit("update_screener_subtitle_lang", payload);
  },
  async updateScreenerResolution(context, payload) {
    context.commit("update_screener_resolution", payload);
  },

  resetPlayerState(context, payload) {
    context.commit('reset');
  },
};

// getters
const getters = {
  getField,
  getScreenerConfig: state => screenerId => {
    if(!state.screener_level[screenerId]){
      return null;
    }

    return state.screener_level[screenerId]
  }
};

// mutations
const mutations = {
  updateField,
  update_screener_config(state,payload) {
    state.screener_level[payload.screener_id] = payload;
  },
  mark_preroll_ended(state,payload) {
    let playerConfig = state.screener_level[payload.screener_id]
    if(playerConfig){
      playerConfig.prerollEnded = true
      state.screener_level[payload.screener_id] = Object.assign({},playerConfig)
    }
  },
  update_movie_index(state, payload){
    let playerConfig = state.screener_level[payload.screener_id]
    if(playerConfig){
      playerConfig.currentMovieIndex = payload.currentMovieIndex
      state.screener_level[payload.screener_id] = Object.assign({},playerConfig)
    }
  },

  update_current_time(state, payload){
    let playerConfig = state.screener_level[payload.screener_id]
    if(playerConfig){
      playerConfig.currentTime = payload.currentTime
      state.screener_level[payload.screener_id] = Object.assign({},playerConfig)
    }
  },

  update_screener_subtitle_lang(state, payload){
    let playerConfig = state.screener_level[payload.screener_id]
    if(playerConfig){
      playerConfig.subtitle_lang = payload.subtitleLang
      state.screener_level[payload.screener_id] = Object.assign({},playerConfig)
    }
  },
  update_screener_resolution(state, payload){
    let playerConfig = state.screener_level[payload.screener_id]
    if(playerConfig){
      playerConfig.resolution = payload.resolution
      state.screener_level[payload.screener_id] = Object.assign({},playerConfig)
    }
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },

};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
